<template>
    <div class="card" id="agencies">
        <div class="card-body">

            <div class="card-title font-weight-bold">
                Benefits & Contributions
                <hr class="mt-1 border-dark"/>
            </div>

            <div class="form-group form-row mb-1" v-for="agencyNumber in crew.crew_agency_numbers" :key="agencyNumber.id">
                <label :for="'agency' + agencyNumber.id"
                       class="col col-sm-3 col-form-label font-weight-bolder text-left form-label-xs"
                >
                    {{agencyNumber.agency.name}}:
                </label>
                <input type="text" readonly :id="'agency' + agencyNumber.id"
                       class="col col-sm-4 form-control form-control-xs form-display h-1x"
                       v-model="agencyNumber.number"
                >

              <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
                <template v-if="crew.active == 1 || isSystemAdmin">
                  <div class="col col-sm-2" >
                    <button class="btn btn-sm btn-xs"
                            data-toggle="modal" data-target="#agencyNumberModal"
                            :title="`EDIT ${agencyNumber.agency.name} NUMBER`"
                            @click="updateAgencyNumberModal(agencyNumber)"
                    >
                      <span class="fas fa-edit"></span>
                    </button>
                    <button class="btn btn-sm btn-xs"
                            :title="`REMOVE ${ agencyNumber.agency.name }`"
                            @click="confirmDeleteCrewAgency(agencyNumber.id)"
                    >
                      <span class="fas fa-minus text-danger"></span>
                    </button>
                  </div>
                </template>

              </template>

            </div>

          <template v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline">
            <template v-if="crew.active == 1 || isSystemAdmin">
              <div class="form-group form-row" >
                <div class="col col-sm-1 offset-7">
                  <button class="btn btn-sm btn-xs"
                          data-toggle="modal" data-target="#newAgencyNumberModal"
                  >
                    <span class="fas fa-plus"></span>
                  </button>
                </div>
              </div>
            </template>
          </template>


        </div>

        <div class="modal fade" id="newAgencyNumberModal" tabindex="-1" role="dialog"
             aria-labelledby="newAgencyNumberModalTitle" aria-hidden="true" v-if="(isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="confirmAddNewCrewAgencyNumber">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="newAgencyNumberModalTitle">
                            NEW BENEFITS & CONTRIBUTION RECORD
                        </h5>
                        <button type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                id="closeNewCrewAgency"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-group form-row mb-1" :class="{'has-error': newAgencyNumberErrors.agency_id}">
                            <label for="newCrewAgency"
                                   class="col col-sm-3 col-form-label font-weight-bolder text-right"
                            >
                                Agency:
                            </label>

                            <div class="col col-sm-6">
                                <select id="newCrewAgency" required
                                        class="form-control form-control-xs"
                                        v-model="newAgencyNumber.agency_id"
                                >
                                    <option :value="null">--- Select Agency ---</option>
                                    <option v-for="agencyKey in agencyKeys" :key="agencyKey.id"
                                            :value="agencyKey.id"
                                    >
                                        {{ agencyKey.name }}
                                    </option>
                                </select>
                                <span class="help-block" v-if="newAgencyNumberErrors.agency_id !== ''">
                                    <small><strong>{{ newAgencyNumberErrors.agency_id }}</strong></small>
                                </span>
                            </div>

                        </div>

                        <div class="form-group form-row mb-1" :class="{'has-error': newAgencyNumberErrors.number}">
                            <label for="newCrewAgencyNumber"
                                   class="col col-sm-3 col-form-label font-weight-bolder text-right"
                            >
                                Number:
                            </label>
                            <div class="col col-sm-6">
                                <input type="text" id="newCrewAgencyNumber" required
                                       class="form-control form-control-xs"
                                       placeholder="TYPE NUMBER HERE"
                                       v-model="newAgencyNumber.number"
                                >
                                <span class="help-block" v-if="newAgencyNumberErrors.number !== ''">
                                    <small><strong>{{ newAgencyNumberErrors.number }}</strong></small>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder">
                            <span class="fas fa-plus"></span>
                            Save
                        </button>
                    </div>

                </form>
            </div>
        </div>

        <div class="modal fade" id="agencyNumberModal" v-if="agencyNumber.agency && (isManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff)"
             tabindex="-1" role="dialog" aria-labelledby="agencyNumberModalTitle" aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="confirmUpdateCrewAgencyNumber">
                    <div class="modal-header">
                        <h5 class="modal-title font-weight-bolder" id="agencyNumberModalTitle">
                            {{ agencyNumber.agency.name }}
                        </h5>
                        <button type="button" id="closeCrewAgency"
                                class="close" data-dismiss="modal" aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group form-row mb-1" :class="{'has-error': agencyNumberErrors.number}">
                            <label for="crewAgencyNumber"
                                   class="col col-sm-3 col-form-label font-weight-bolder text-right"
                            >
                                Number:
                            </label>

                            <div class="col col-sm-6">
                                <input type="text" id="crewAgencyNumber"
                                       class="form-control form-control-xs"
                                       placeholder="TYPE NUMBER HERE"
                                       v-model="agencyNumber.number"
                                >
                                <span class="help-block" v-if="agencyNumberErrors.number !== ''">
                                    <small><strong>{{ agencyNumberErrors.number }}</strong></small>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-sm btn-warning font-weight-bolder">
                            <span class="fas fa-edit"></span>
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>

    import { mapActions, mapGetters } from 'vuex';
    import { vueAppMixin } from "../../../../../../../mixins/vueAppMixin";
    import { formMixin } from "../../../../../../../mixins/formMixin";
    import {gateMixin} from "@/mixins/gateMixin";

    export default {
        name: "AgencyNumbers",
        mixins: [ vueAppMixin, formMixin, gateMixin ],
        data() {
            return {
                agencyNumber: {},
                newAgencyNumber: {},
                agencyNumberErrors: [],
                newAgencyNumberErrors: []
            }
        },

        methods: {
            ...mapActions([ 'updateCrewAgencyNumber', 'getAgencyKeys', 'addCrewAgencyNumber', 'deleteCrewAgency' ]),

            updateAgencyNumberModal(agencyNumber) {
                this.agencyNumber = Object. assign({}, agencyNumber);
            },

            async confirmUpdateCrewAgencyNumber() {
                if(await this.confirmUpdate('Are you sure you want to update this record?')) {
                    let params = {
                        crewAgencyId: this.agencyNumber.id,
                        number: this.agencyNumber.number,
                        active: this.agencyNumber.active
                    };
                    let updatedCrewAgencyNumber = await this.updateCrewAgencyNumber(params);
                    if(updatedCrewAgencyNumber) {
                        if(updatedCrewAgencyNumber.errors) {
                            this.agencyNumberErrors = updatedCrewAgencyNumber.errors;
                        } else {
                            this.successAlert(`${this.agencyNumber.agency.name} Successfully Updated`, 'UPDATE');
                            this.agencyNumber = {};
                            document.getElementById('closeCrewAgency').click();
                        }
                    } else {
                        this.errorAlert(`${this.agencyNumber.agency.name} Failed to Update`, 'UPDATE');
                    }
                }
            },

            async confirmAddNewCrewAgencyNumber() {
                if(await this.confirmCreateAlert('Are you sure you want to add this record')) {
                    let newCrewAgencyNumber = await this.addCrewAgencyNumber(this.newAgencyNumber);
                    if(newCrewAgencyNumber) {
                        if(newCrewAgencyNumber.errors) {
                            this.newAgencyNumberErrors = newCrewAgencyNumber.errors;
                        } else {
                            this.successAlert(`New Agency Number Successfully Added`, 'Create');
                            this.refreshNewAgencyNumber();
                            document.getElementById('closeNewCrewAgency').click();
                        }
                    } else {
                        this.errorAlert('Crew Agency Number Failed to Save', 'CREATE');
                    }
                }
            },

            async confirmDeleteCrewAgency(crewAgencyId) {
                if(await this.confirmDeleteAlert()) {
                    if(await this.deleteCrewAgency(crewAgencyId)) {
                        this.successAlert('Crew Agency Successfully Deleted', 'DELETE');
                    }
                }
            },

            refreshNewAgencyNumber() {
                this.newAgencyNumber = { crew_id: this.$route.params.id, agency_id: null, active: true }
            }
        },

        computed: {
            ...mapGetters([ 'crew', 'agencyKeys' ])
        },

        created() {

        },

        mounted() {
          $('#newAgencyNumberModal').on('hidden.bs.modal',
            () => this.refreshNewAgencyNumber()
          )

            this.getAgencyKeys();
            this.refreshNewAgencyNumber();
        }

    }
</script>

<style scoped>

</style>
